module.exports = new __parcel__URL__("na-logo-dark-small.png.3f773e18.webp").toString();